module.exports = "https://www.gc-pro.gnp.com.mx/093d2f87a8651658ba345ec19104f6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-gnp.png
// module id = 8151
// module chunks = 0